import { useState } from 'react';

export function useLeadSelection() {
  const [selectedLeads, setSelectedLeads] = useState(new Set());

  const handleSelectAll = (checked, leadsData) => {
    if (checked) {
      const allIds = new Set(leadsData.map(lead => lead._id));
      setSelectedLeads(allIds);
    } else {
      setSelectedLeads(new Set());
    }
  };

  const handleSelectLead = (leadId, checked) => {
    const newSelection = new Set(selectedLeads);
    if (checked) {
      newSelection.add(leadId);
    } else {
      newSelection.delete(leadId);
    }
    setSelectedLeads(newSelection);
  };

  const clearSelection = () => {
    setSelectedLeads(new Set());
  };

  const getSelectionState = (leadsData) => {
    const isAllSelected = leadsData.length > 0 && selectedLeads.size === leadsData.length;
    const isIndeterminate = selectedLeads.size > 0 && selectedLeads.size < leadsData.length;
    
    return { isAllSelected, isIndeterminate };
  };

  return {
    selectedLeads,
    handleSelectAll,
    handleSelectLead,
    clearSelection,
    getSelectionState
  };
}
